import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { SettingsService } from "../../../services/shared/settings.service";

@Component({
  selector: 'app-functionbuttonset',
  templateUrl: './functionbuttonset.component.html',
  styleUrls: ['./functionbuttonset.component.scss']
})
export class FunctionButtonsetComponent implements OnInit {
  @Output()
  public processButtonClicked = new EventEmitter();
  @Input()
  public isProcessDisabled: boolean;
  @Input() buttonText: string = '';

  constructor(public settings: SettingsService) { }

  public ngOnInit() {
  }

  public onProcessClick() {
    this.processButtonClicked.emit();
  }
}
